import type { InquiryServicePorts } from "../../model";

import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  fullName,
  message,
  createdAt,
  adminComment,
  email,
  phone,
  ...rest
}: Common.OutSchema): InquiryServicePorts.ProviderIos.Common.OutSchema {
  return {
    ...rest,
    fullName: fullName ?? EMPTY,
    message: message ?? EMPTY,
    createdAt: new Date(createdAt),
    adminComment: adminComment ?? EMPTY,
    contacts: {
      email: email ?? EMPTY,
      phone: phone ?? EMPTY,
    },
  };
}

export { mapDtoToEntity };
